import StringField from 'modules/shared/fields/stringField';

export default class IdField extends StringField {}
